import React from 'react';
import { useTranslation } from 'react-i18next';
import MobileDetect from 'mobile-detect';

import { Text16 } from '../../../ui/Text16';
import MasterCard from '../../../assets/FooterLogos/mastercard.svg';
import VisaCard from '../../../assets/FooterLogos/visa.svg';
import {    
    FooterMenuTitle,
    RuleLink,
    RulesItem,
    MasetroCardLogo,
    CardIcons,    
} from '../footer.style';

export const Rules: React.FC<{}> = () => {
    const { t } = useTranslation();
    const md = new MobileDetect(window.navigator.userAgent);
    return(
        <RulesItem>
            <FooterMenuTitle>{t('rules')}</FooterMenuTitle>
            <RuleLink to='/terms-and-conditions'>
                <Text16>{t('user_agreement')}</Text16>
            </RuleLink>
            <RuleLink to='/personal-data-policy'>
                <Text16>{t('user_policy')}</Text16>
            </RuleLink>
            <RuleLink to='/information-for-consumer'>
                <Text16>{t('consumer_information')}</Text16>
            </RuleLink>
            <RuleLink to='/terms-of-payment-and-payments'>
                <Text16>{t('terms_of_payment')}</Text16>
            </RuleLink>
            {
                md.mobile() ? (
                    <CardIcons>
                        <MasetroCardLogo
                            src={MasterCard}
                            />
                            <img
                            src={VisaCard}
                            alt='Visa Card'
                            loading='lazy'
                        />
                    </CardIcons>
                ) : null
            }
        </RulesItem>
    )
}